<script lang="ts">
  import ControlGroup from '../../../../../components/control-group/ControlGroup.svelte'
  import ControlGroupContent from '../../../../../components/control-group/ControlGroupContent.svelte'
  import { Grid3x3Icon, MinusIcon } from '@lucide/svelte'
  import { ToggleGroup, ToggleGroupItem, ToggleGroupReset } from '../../../../../components/toggle-group'
  import { PolarGridIcon } from '../../../../../components/icons'
  import i18n from '../../../../../i18n'
  import InputLabel from '../InputLabel.svelte'

  let {
    gridType = $bindable(),
    hideCartesian = false,
    hidePolar = false,
  } = $props()

  const getValueFromPrinter = (
    printerValue?: string,
  ): ('polar' | 'cartesian')[] | null => {
    switch (printerValue) {
      case 'polar':
        return ['polar']
      case 'cartesian':
        return ['cartesian']
      case 'both':
        return ['polar', 'cartesian']
      default:
        return null
    }
  }

  let value = $state<('polar' | 'cartesian')[] | null>(
    getValueFromPrinter(gridType),
  )

  $effect(() => {
    let formattedValue: string

    if (!value || !value.length) {
      formattedValue = 'none'
    }
    else if (value.length === 1) {
      formattedValue = value[0]
    }
    else {
      formattedValue = 'both'
    }

    gridType = formattedValue
  })
</script>

<ControlGroup>
  <InputLabel>
    {$i18n.t('project.rightBar.zoneSettings.grid.title')}
  </InputLabel>
  <ControlGroupContent>
    <ToggleGroup name="grid" type="multiple" bind:value>
      <ToggleGroupReset
        title={$i18n.t('project.rightBar.zoneSettings.grid.none')}
      >
        <MinusIcon size="1rem" />
      </ToggleGroupReset>
      {#if !hidePolar}
        <ToggleGroupItem
          title={$i18n.t('project.rightBar.zoneSettings.grid.polar')}
          value="polar"
        >
          <PolarGridIcon />
        </ToggleGroupItem>
      {/if}
      {#if !hideCartesian}
        <ToggleGroupItem
          title={$i18n.t('project.rightBar.zoneSettings.grid.cartesian')}
          value="cartesian"
        >
          <Grid3x3Icon size="1rem" strokeWidth={1.7} />
        </ToggleGroupItem>
      {/if}
    </ToggleGroup>
  </ControlGroupContent>
</ControlGroup>
